import { render, staticRenderFns } from "./PsiDetailSummary.vue?vue&type=template&id=c2ea888e"
import script from "./PsiDetailSummary.vue?vue&type=script&lang=js"
export * from "./PsiDetailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports